import { MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useLang } from "../../lib/i18n";

const PLACES = [
    { name: "Drunen", home: true },
    { name: "'s-Hertogenbosch" },
    { name: "Vlijmen" },
    { name: "Vught" },
    { name: "Den Dungen" },
    { name: "Sint-Michielsgestel" },
    { name: "Berlicum" },
    { name: "Rosmalen" },
    { name: "Kerkdriel" },
];

export const Area = () => {
    const { t } = useLang();
    return (
    <section id="werkgebied" data-testid="area-section" className="relative overflow-hidden bg-night-900/40 py-24 sm:py-32">
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-40 top-1/2 hidden h-[560px] w-[560px] -translate-y-1/2 lg:block"
        >
            <div className="absolute inset-0 rounded-full border border-amber-400/10" />
            <div className="absolute inset-[15%] rounded-full border border-amber-400/15" />
            <div className="absolute inset-[30%] rounded-full border border-amber-400/20" />
            <div className="absolute inset-[45%] rounded-full border border-amber-400/30" />
            <div className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 animate-pulse-dot rounded-full bg-amber-400 shadow-[0_0_30px_rgba(245,158,11,0.8)]" />
        </div>

        <div className="container-x relative">
            <SectionHeading
                num="04"
                eyebrow={t.area.eyebrow}
                title={t.area.title}
                text={t.area.text}
            />
            <div className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="area-places">
                {PLACES.map((place, i) => (
                    <Reveal key={place.name} delay={0.04 * i}>
                        <div
                            data-testid={`area-place-${i}`}
                            className={`group flex items-center justify-between rounded-xl border px-6 py-5 transition-[border-color,background-color,transform] duration-400 hover:-translate-y-0.5 ${
                                place.home
                                    ? "border-amber-400/50 bg-amber-400/8"
                                    : "border-white/8 bg-night-850/70 hover:border-amber-400/30"
                            }`}
                        >
                            <span className="flex items-center gap-3">
                                <MapPin size={17} className={place.home ? "text-amber-400" : "text-slate-500 transition-colors group-hover:text-amber-400"} />
                                <span className={`font-display font-wide text-lg font-bold uppercase ${place.home ? "text-amber-300" : "text-white"}`}>
                                    {place.name}
                                </span>
                            </span>
                            {place.home ? (
                                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber-400">{t.area.homeBadge}</span>
                            ) : (
                                <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
                            )}
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-10 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg" data-testid="area-note">
                    {t.area.note}
                </p>
            </Reveal>
        </div>
    </section>
    );
};
